import { MutationTree } from "vuex";
import {
  TeamState,
  Member,
  MemberList,
  PendingMember,
  InviteSender,
} from "../types";

const mutations: MutationTree<TeamState> = {
  setSuperAdminCount(state, total: number) {
    state.superAdminCount = total;
  },
  setInviteSender(state, inviteSender: InviteSender) {
    state.inviteSender = inviteSender;
  },
  setUsers(state, members: MemberList) {
    state.members = members;
  },
  setPendingMembers(state, members: PendingMember[]) {
    state.pendingMembers = members;
  },
  setPageIndex(state, pageIndex: number) {
    state.members.pageIndex = pageIndex;
  },
  setHasNextPage(state, hasNextPage: boolean) {
    state.members.hasNextPage = hasNextPage;
  },
  pushNewUsers(state, members: Member[]) {
    state.members.items.push(...members);
  },
  setCurrentMember(state, member: Member) {
    state.currentMember = member;
  },
  setCurrentPendingMember(state, pendingMember) {
    state.currentPendingMember = pendingMember;
  },
};

export default mutations;
